import { render, staticRenderFns } from "./AuthTokenSetupDialogue.vue?vue&type=template&id=2a53687f&scoped=true&"
import script from "./AuthTokenSetupDialogue.vue?vue&type=script&lang=js&"
export * from "./AuthTokenSetupDialogue.vue?vue&type=script&lang=js&"
import style0 from "./AuthTokenSetupDialogue.vue?vue&type=style&index=0&id=2a53687f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53687f",
  null
  
)

export default component.exports